<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.templateClassification">
            <div class="item">分类类别：{{ mapSourceType(form.beforeStr.templateClassification.source_type || form.beforeStr.templateClassification.sourceType) }}</div>
            <div class="item">上级分类：{{ beforeparentName }}</div>
            <div class="item">分类名称：{{form.beforeStr.templateClassification.name}}</div>
           
            <!-- <div class="item">分类等级：{{ mapCategoryLevel(form.beforeStr.templateClassification.category_level || form.beforeStr.templateClassification.categoryLevel) }}</div> -->


            <div class="item">背景图：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.templateClassification.bg_image" :preview-src-list="[form.beforeStr.templateClassification.bg_image]" v-if="form.beforeStr.templateClassification.bg_image"></el-image></div>
            <div class="item">描述：{{form.beforeStr.templateClassification.description}}</div>
            <div class="item">页面排序：{{form.beforeStr.templateClassification.order_no}}</div>
            <div class="item">状态：{{form.beforeStr.templateClassification.state?'启用':'禁用'}}</div>
            <div class="item">查看权限类型：{{ formatAuthType(form.beforeStr.templateClassification) }}</div>
            <div class="item auth-detail" v-if="beforetemplateClassificationAuthName">
              <div class="auth-detail-content">beforetemplateClassificationAuthName</div>
            </div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.templateClassification">
            <div class="item">分类类别：{{ mapSourceType(form.afterStr.templateClassification.source_type || form.afterStr.templateClassification.sourceType) }}</div>
            <div class="item">上级分类：{{afterparentName}}</div>
            <div class="item">分类名称：{{form.afterStr.templateClassification.name}}</div>
          
            <!-- <div class="item">分类等级：{{ mapCategoryLevel(form.afterStr.templateClassification.category_level || form.afterStr.templateClassification.categoryLevel) }}</div> -->
        
            <div class="item">背景图：<el-image style="width: 50px; height: 50px" :src="form.afterStr.templateClassification.bg_image" :preview-src-list="[form.afterStr.templateClassification.bg_image]" v-if="form.afterStr.templateClassification.bg_image"></el-image></div>
            <div class="item">描述：{{form.afterStr.templateClassification.description}}</div>
            <div class="item">页面排序：{{form.afterStr.templateClassification.order_no}}</div>
            <div class="item">状态：{{form.afterStr.templateClassification.state?'启用':'禁用'}}</div>
            <div class="item">查看权限类型：{{ formatAuthType(form.afterStr.templateClassification) }}</div>
            <div class="item auth-detail" v-if="aftertemplateClassificationAuthName">
              <div class="auth-detail-content">{{ aftertemplateClassificationAuthName }}</div>
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import templateClassificationApi from "@/api/marketing/templateClassification";
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      afterparentName: '无',
      beforeparentName: '无',
      aftertemplateClassificationAuthName: '',
      beforetemplateClassificationAuthName: ''
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
        const afterStrParentId=this.form.afterStr.templateClassification.parent_id;
        const beforeStrParentId=this.form.beforeStr.templateClassification.parent_id;
        if(afterStrParentId&&afterStrParentId>0){
          this.getTemplateClassificationName(afterStrParentId).then(name => {
            this.afterparentName = name;
          });
        }
        if(beforeStrParentId&&beforeStrParentId>0){
          this.getTemplateClassificationName(beforeStrParentId).then(name => {
              this.beforeparentName = name;
          });
        }
       const afterStrAuth=this.form.afterStr.templateClassificationAuth;
       const beforeStrAuth=this.form.beforeStr.templateClassificationAuth;
       if(afterStrAuth&&afterStrAuth.length>0){
        this.aftertemplateClassificationAuthName=this.getAuthDetail(afterStrAuth,this.form.afterStr.templateClassification);
       }
       if(beforeStrAuth&&beforeStrAuth.length>0){
        this.beforetemplateClassificationAuthName=this.getAuthDetail(beforeStrAuth,this.from.beforeStr.templateClassification);
       }

      })
    },
    getTemplateClassificationName(id) {
      if (!id) return '无'
      return templateClassificationApi.fetchById(id).then(res => {
        return res.data.name
      }).catch(err => {
        return '无'
      })
    },
    mapCategoryLevel(val) {
      if (val === 1 || val === '1') return '一级'
      if (val === 2 || val === '2') return '二级'
      return val === 0 || val === '0' || val == null ? '-' : String(val)
    },
    mapSourceType(val) {
      const map = {
        1: '分享物料',
        2: '项目管理',
        3: '顾客物料',
        4: '案例展示',
        5: '业务物料',
        6: '品宣',
        7: '皮科普药'
      }
      const num = typeof val === 'string' ? parseInt(val, 10) : val
      return map[num] || (val == null ? '-' : String(val))
    },
    displayParent(row) {
      const name = row.parent_name || row.parentName
      const id = row.parent_id != null ? row.parent_id : row.parentId
      if (name) return name
      if (id && Number(id) !== 0) return id
      return '-'
    },
    formatAuthType(templateClassification) {
      if (!templateClassification) return '-'
      const authType = templateClassification.auth_type
      if (authType === 1) return '按身份'
      if (authType === 2) return '按指定人'
      return '-'
    },
    getAuthDetail(templateClassificationAuth,templateClassification) {
      if (!templateClassificationAuth || !Array.isArray(templateClassificationAuth) || templateClassificationAuth.length === 0) {
        return ''
      }
      const authType=formatAuthType(templateClassification);
      // 按 level_source 分组
      const grouped = {}
      templateClassificationAuth.forEach(item => {
        const source = item.level_source
        if (!grouped[source]) {
          grouped[source] = []
        }
        grouped[source].push(item.level_id)
      })
      
      const parts = []
      
      // level_source: 1 - 身份等级
      if (grouped[1] && grouped[1].length > 0) {
        const levels = grouped[1].filter(id => id > 0).sort((a, b) => b - a)
        // level_id 到文本的映射
        const levelMap = {
          1: '营销总监',
          2: '营销经理',
          3: '大区经理',
          4: '地区经理',
          5: '县区经理',
          6: '研修班',
          7: '体验班',
          8: '普通用户'
        }
        // 循环遍历 levels 数组，将每个 level_id 转换为对应的文本
        levels.forEach(levelId => {
          const levelText = levelMap[levelId]

          if (levelText && !parts.includes(levelText)) {
            parts.push(levelText)
            if(authType===2){
              // parts.push(levelText)
            }
          }
        })
      }
      
      // level_source: 2 - 其他身份等级
      if (grouped[2] && grouped[2].length > 0) {
        const levels = grouped[2].filter(id => id > 0).sort((a, b) => b - a)
           // level_id 到文本的映射
           const teacherlevelMap = {
          1: '技术总监',
          2: '技术经理',
          3: '技术老师',
          4: '带教老师'
        }
         // 循环遍历 levels 数组，将每个 level_id 转换为对应的文本
         levels.forEach(levelId => {
          const levelText = teacherlevelMap[levelId]
          if (levelText && !parts.includes(levelText)) {
            parts.push(levelText)
          }
        })
      }
      
      // level_source: 3 - 全部
      if (grouped[3] && grouped[3].length > 0) {
        parts.push('内部员工')
      }
      
      return parts.length > 0 ? parts.join('、') : ''
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.auth-detail {
  padding-left: 20px;
  color: #666;
  font-size: 13px;
  .auth-detail-content {
    line-height: 1.6;
  }
}
</style>
